import http from 'hub-http/clients/apiClient';
import { BASE_URI_PROGRESS } from '../../constants/ApiConstants';
import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { create } from 'zustand';
import { useCallback } from 'react';
import produce from 'immer';
import { updateCache } from '../../utils/DataFetchingClientCache.new';
import { GET_USER_PROGRESS_QUERY } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService.dfc.new';
const UPDATE_AWARD_PERMISSION = registerMutation({
  fieldName: 'updateAwardPermission',
  fetcher({
    awardCode,
    shouldBePublic
  }) {
    return http.put(`${BASE_URI_PROGRESS}/granted-certifications/permission`, {
      data: {
        awardCode,
        isPublic: shouldBePublic
      }
    });
  }
});
const useAwardPermissionUpdating = create(set => ({
  isUpdatingPermission: {},
  setIsUpdatingPermission: (awardCode, isUpdatingPermission) => set(produce(state => {
    state.isUpdatingPermission[awardCode] = isUpdatingPermission;
  }))
}));
const updateAwardVisibilityInCache = (trackId, shouldBePublic) => {
  updateCache(GET_USER_PROGRESS_QUERY, draft => {
    var _draft$progress;
    const trackProgress = (_draft$progress = draft.progress) === null || _draft$progress === void 0 ? void 0 : _draft$progress.find(progress => progress.type === 'TRACK' && progress.id === trackId);
    if (!(trackProgress !== null && trackProgress !== void 0 && trackProgress.award)) return;
    trackProgress.award.visibility = shouldBePublic ? 'PUBLIC' : 'PRIVATE';
  }, {
    requestedProgress: [{
      id: trackId,
      type: 'TRACK'
    }]
  });
};
export const useUpdateAwardPermission = (awardCode, shouldBePublic, trackId) => {
  const [mutate, {
    loading: updateAwardPermissionLoading,
    called: updateAwardPermissionCalled,
    error: updateAwardPermissionError
  }] = useMutation(UPDATE_AWARD_PERMISSION, {
    variables: {
      awardCode,
      shouldBePublic
    },
    update() {
      updateAwardVisibilityInCache(trackId, shouldBePublic);
    }
  });
  const {
    isUpdatingPermission,
    setIsUpdatingPermission
  } = useAwardPermissionUpdating();
  const updateAwardPermission = useCallback(() => {
    setIsUpdatingPermission(awardCode, true);
    return mutate().then(data => {
      setIsUpdatingPermission(awardCode, false);
      return data;
    });
  }, [awardCode, mutate, setIsUpdatingPermission]);
  return [updateAwardPermission, {
    updateAwardPermissionLoading,
    updateAwardPermissionGlobalLoading: isUpdatingPermission[awardCode],
    updateAwardPermissionCalled,
    updateAwardPermissionError
  }];
};